export const links = [
    {
        "nombre" : "Transparencia",
        "link" : "/transparencia",
        "children" : [
            {
                "subMenuNombre" : "48 Rubros",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
            {
                "subMenuNombre" : "Rubros Anteriores",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            } /*,
            {
                "subMenuNombre" : "Ley de Disciplina Financiera",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            },
            {
                "subMenuNombre" : "Armonización Contable",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            },
            {
                "subMenuNombre" : "Cuenta Pública",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            } */
        ]
    },
    /*{
        "nombre" : "Ligas de interés",
        "link" : "/Transparencia",
        "submenu" : [
            
        ]
    },
    {
        "nombre" : "Bolsa de Trabajo",
        "link" : "/Transparencia",
         
    },
    {
        "nombre" : "Servicios",
        "link" : "/Transparencia",
          
    },*/
    {
        "nombre" : "Armonización Contable",
        "link" : "/Transparencia/Armonizacion",
        "submenu" : [
            
        ]
     },
     {
        "nombre" : "Licitaciones",
        "link" : "/Transparencia/Licitaciones",
        "submenu" : [
            
        ]
     }, 
    {
        "nombre" : "Cuenta Pública",
        "link" : "/Transparencia/AContable/cpublica",
        "submenu" : [
            
        ]
     },
     {
        "nombre" : "Ligas de Interes",
        "link" : "/Transparencia/Normatividad/ligasInteres",
        "submenu" : [
            
        ]
     },
      
]


